import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_18u4q5xcev: FaireBrandEntity = {
  token: "b_18u4q5xcev",
  type: "brand",
  name: "Green Belly Foods",
  avatarUrl:
    "https://cdn.faire.com/fastly/8b60a9f031fefb115a63ef4d29b6f05a08ac51524b2db3069c1cdec73a407cbf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/52c4352aa39180bc0e5919b4449da7ad51fee021cbdd2c83f25b25b8438ddf02.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8b60a9f031fefb115a63ef4d29b6f05a08ac51524b2db3069c1cdec73a407cbf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/52c4352aa39180bc0e5919b4449da7ad51fee021cbdd2c83f25b25b8438ddf02.jpeg",
  location: "Boulder, CO, USA",
  minimumOrderDollars: 50,
  rating: 4.4,
  reviewCount: 7,
  isInsider: true,
  description:
    "Green Belly Foods is a small family business started in Colorado by two cousins Juan and Charlie. \n\nThey craft artisanal Guatemalan foods and experiences that people love to share. \n\nThe dream started when Juan shared his mom’s secret hot sauce with friends. \n\nHis friends pushed him to enter farmers markets and people went crazy over the unique fresh flavor; and there was only one option from there! \n\nNow when not slinging sauce you can find Juan and Charlie dancing in the kitchen and creating new flavors they love to share!!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:43.627Z",
    importedBy: "entity-db-cli",
  },
};
